import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { icons } from '../../../configs/Icons';
import { useAuth } from '../../Contexts/AuthProvider';
import { UserCardV2 } from '../../features/User/UserCard';
import { useTemplate } from '../../features/template/TemplateProvider';
import { GetCurrentUrl } from '../../utils/URL';
import { handleUserLogOutOpe } from '../AuthControl/UserControlOperation';

function UserProfileCard({ isShow, setIsShow, profileData }) {
    const { authStateUpdated } = useAuth();

    const token = localStorage.getItem('token');
    const { setMessage } = useTemplate();
    const currentUrl = GetCurrentUrl();
    if (!isShow) {
        return null;
    }

    const handleLogout = (e) => {
        e.preventDefault();
        handleUserLogOutOpe(token)
            .then(({ title }) => {
                localStorage.removeItem('token');
                setMessage({ type: 'success', text: title });
                authStateUpdated();
                window.location.href = `/login/?url=${currentUrl}`;
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.toString(0) });
            });
    };

    return (
        <div className="user-profile-card bg-white border border-primary-100 fixed top-16 right-4 z-[999999] w-52 shadow-[1px_1px_12px_2px_#e6e6e6] rounded-10">
            <div className="flex flex-col justify-start items-start p-2 [&>a]:inline-block [&>a]:w-full">
                <UserCardV2
                    title={profileData?.fullName}
                    subTitle={<span className="capitalize">{profileData?.role}</span>}
                    hide
                    className="px-2 rounded-5"
                />
                <Link
                    to="/profile"
                    onClick={() => setIsShow(false)}
                    className="rounded-5 p-2 py-1.5 text-base font-medium text-primary hover:bg-primary-50 flex justify-start items-center"
                >
                    My Profile
                </Link>
                <Link
                    to="/security"
                    onClick={() => setIsShow(false)}
                    className="rounded-5 p-2 py-1.5 text-base font-medium text-primary hover:bg-primary-50 flex justify-start items-center"
                >
                    Security Settings
                </Link>
            </div>
            <div className="border-t border-primary-100">
                <button
                    onClick={handleLogout}
                    type="button"
                    className="w-full p-2 px-4 text-base font-medium text-primary hover:bg-primary-50 flex justify-start items-center"
                >
                    Log out
                </button>
            </div>
        </div>
    );
}

function UserProfilePage() {
    const { authInfo } = useAuth();
    const [isShow, setIsShow] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (!ref.current?.contains(e.target)) {
                setIsShow(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);
    return (
        <div className="user-profile relative" ref={ref}>
            <div
                onClick={() => setIsShow((cuData) => !cuData)}
                role="button"
                tabIndex={-1}
                className="user-icon w-9 h-9 cursor-pointer overflow-auto rounded-full border border-primary-200"
            >
                <img
                    src={authInfo.data.photoUrl || icons.defaultAvatar}
                    alt={authInfo.data.fullName || 'Avatar'}
                    className="w-full h-full block object-cover object-top"
                />
            </div>

            <UserProfileCard
                isShow={isShow}
                setIsShow={setIsShow}
                profileData={authInfo?.data || {}}
            />
        </div>
    );
}

export default UserProfilePage;
